// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".corner-wrapper[data-v-66a5837f]{display:none}@media(min-width:1240px){.corner-wrapper[data-v-66a5837f]{display:inline-block;height:40px;margin-top:-10px;width:200px}.corner-wrapper__img[data-v-66a5837f]{height:40px}}@media(min-width:1360px){.corner-wrapper[data-v-66a5837f]{display:inline-block;height:50px;width:250px}.corner-wrapper__img[data-v-66a5837f]{height:50px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
